import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PayrollDeductComponent } from './payroll-deduct/payroll-deduct.component';

const routes: Routes = [
  {
    path: '',
    component: PayrollDeductComponent,
    data: { title: null },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PayrollDeductRoutingModule {}
